import {
    DefaultPageParams,
    DefaultSortParams,
    Entity,
    IParams,
    PageParams,
    QueryParams,
    SortParams,
} from "../../models";

export interface QueryParamAction {
    type: "update" | "replace" | "clear";
    entity: Entity;
    paramType: "page" | "sort" | "query";
    key?: string;
    value?: number | string;
    payload?: unknown;
}

export const QueryParamsReducer = (state: IParams, action: QueryParamAction): IParams => {
    const { entity, key, payload, paramType, type, value } = action;
    const updatedState = { ...state };

    if (type === "update" && !!key) {
        switch (paramType) {
            case "page":
                updatedState[entity].pageParams = {
                    ...updatedState[entity].pageParams,
                    [key]: value as number,
                };
                if (key === "pageSize") updatedState[entity].pageParams.page = 1;
                break;
            case "sort":
                updatedState[entity].sortParams = {
                    ...updatedState[entity].sortParams,
                    [key]: value as string,
                };
                break;
            case "query":
                updatedState[entity].queryParams = {
                    ...updatedState[entity].queryParams,
                    [key]: value as string,
                };
                updatedState[entity].pageParams = {
                    ...updatedState[entity].pageParams,
                    page: 1,
                };
                break;
        }
    } else if (type === "replace") {
        switch (paramType) {
            case "page":
                updatedState[entity].pageParams = payload as PageParams;
                break;
            case "sort":
                updatedState[entity].sortParams = payload as SortParams;
                break;
            case "query":
                updatedState[entity].queryParams = payload as QueryParams;
                updatedState[entity].pageParams = {
                    ...updatedState[entity].pageParams,
                    page: 1,
                };
                break;
        }
    } else if (type === "clear") {
        switch (paramType) {
            case "query":
                updatedState[entity].queryParams = {};
                updatedState[entity].pageParams = {
                    ...updatedState[entity].pageParams,
                    page: 1,
                };
                break;
            case "sort":
                updatedState[entity].sortParams = DefaultSortParams;
                break;
            case "page":
                updatedState[entity].pageParams = DefaultPageParams;
                break;
        }
    }

    return updatedState;
};
